import * as React from "react";
import BtnBase from "@warda/library-ui/core/BtnBase";
import { createUseStyles } from "react-jss";
import classnames from "classnames";
import hexToRgbA from "@warda/library-ui/utils/hexToRgbA";
import { getTheme } from "@warda/library-ui/theme";
import Avatar from "@warda/library-ui/core/Avatar";
import { getUser } from "@warda/library-ui/utils/getUser";
import ModalLogout from "./ModalLogout";
import WindowProfile from "./WindowProfile";
import { useContextTenantM2ms, useContextTenantUsers, useContextUserData, } from "../Main";
const SIZE = 30;
const useStyles = createUseStyles({
    btnProfile: {
        overflow: "hidden",
        height: SIZE,
        width: SIZE,
        borderRadius: getTheme().borderRadius,
        color: getTheme().colors.theme1,
        boxSizing: "content-box",
        margin: "0 1px",
        border: "1px solid transparent",
    },
    btnProfileSelected: {
        borderColor: getTheme().colors.theme1,
    },
    avatar: {
        borderRadius: 0,
        backgroundColor: hexToRgbA(getTheme().colors.theme1, 0.25),
    },
});
const BtnWindowProfile = ({ onLogout }) => {
    const classes = useStyles({});
    const users = useContextTenantUsers();
    const m2ms = useContextTenantM2ms();
    const currUser = useContextUserData();
    const userMock = getUser(currUser.userId, users, m2ms);
    const menuRef = React.useRef(null);
    const [menu, setMenu] = React.useState(false);
    const onMenuOpen = React.useCallback(() => {
        setMenu(true);
    }, []);
    const onMenuClose = React.useCallback(() => {
        setMenu(false);
    }, []);
    const [modalLogout, setModalLogout] = React.useState(false);
    const onModalLogoutClose = React.useCallback(() => {
        setModalLogout(false);
    }, []);
    const onModalLogoutOpen = React.useCallback(() => {
        setModalLogout(true);
        setMenu(false);
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(BtnBase, { ref: menuRef, className: classnames({
                [classes.btnProfile]: true,
                [classes.btnProfileSelected]: menu,
            }), onClick: onMenuOpen, tooltip: "Profile" },
            React.createElement(Avatar, { className: classes.avatar, size: SIZE, src: userMock.avatar, text: userMock.avatarText, icon: userMock.avatarIcon })),
        React.createElement(WindowProfile, { open: menu, anchorEl: menuRef.current, onClose: onMenuClose, onModalLogout: onModalLogoutOpen }),
        React.createElement(ModalLogout, { open: modalLogout, onCancel: onModalLogoutClose, onLogout: onLogout })));
};
export default BtnWindowProfile;
